export default function wordcount(content) {
  const averageWordsPerMinute = 200
  let cont = content

  // remove html elements
  cont = cont.replace(/<[^>]*>/g, " ")
  cont = cont.replace(/\s+/g, " ")
  cont = cont.trim()

  const wordCount = cont.split(" ").length
  const readTime = Math.round(wordCount / averageWordsPerMinute)

  return readTime
}
